/**
 * Фильтр поиска по темам nft_topic: dropdown на десктопе, drawer на мобильном.
 */
class SearchTopicFilter {

    /**
     * Инициализирует все фильтры тем на странице.
     */
    constructor() {
        document.querySelectorAll('[data-search-topic-filter]').forEach((root) => {
            this.bindRoot(root);
        });
    }

    /**
     * Навешивает открытие панели и отправку формы на корень фильтра.
     */
    bindRoot(root) {
        const trigger = root.querySelector('.search-topic-filter__trigger');
        const dropdown = root.querySelector('.search-topic-filter__dropdown');
        const form = root.querySelector('.search-topic-filter__form');

        if (!trigger || !dropdown || !form) {
            return;
        }

        this.bindTrigger(root, trigger, dropdown);
        this.bindReset(form);
        this.bindChange(form);
        this.bindDismiss(root, trigger, dropdown);
    }

    /**
     * Открывает или закрывает панель по кнопке «Фильтр по темам».
     */
    bindTrigger(root, trigger, dropdown) {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            this.toggle(root, dropdown);
        });
    }

    /**
     * Сбрасывает выбранные темы и отправляет форму.
     */
    bindReset(form) {
        const reset = form.querySelector('.search-topic-filter__reset');

        if (!reset) {
            return;
        }

        reset.addEventListener('click', (e) => {
            e.preventDefault();
            this.reset(form);
        });
    }

    /**
     * Отправляет форму при выборе темы.
     */
    bindChange(form) {
        form.addEventListener('change', (e) => {
            const input = e.target;
            if (input instanceof HTMLInputElement && input.classList.contains('search-topic-filter__input')) {
                form.requestSubmit();
            }
        });
    }

    /**
     * Закрывает панель по фону, крестику, клику снаружи и Escape.
     */
    bindDismiss(root, trigger, dropdown) {
        const backdrop = root.querySelector('.search-topic-filter__backdrop');
        const closeBtn = root.querySelector('.search-topic-filter__drawer-close');

        if (backdrop) {
            backdrop.addEventListener('click', () => {
                this.close(root, dropdown);
            });
        }

        if (closeBtn) {
            closeBtn.addEventListener('click', (e) => {
                e.preventDefault();
                this.close(root, dropdown);
            });
        }

        document.addEventListener('click', (e) => {
            if (!root.contains(e.target)) {
                this.close(root, dropdown);
            }
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && root.classList.contains('search-topic-filter--open')) {
                this.close(root, dropdown);
                trigger.focus();
            }
        });
    }

    /**
     * Проверяет мобильную ширину, на которой фильтр открывается как drawer.
     */
    isMobile() {
        return window.matchMedia('(max-width: 768px)').matches;
    }

    /**
     * Показывает или скрывает панель тем.
     */
    toggle(root, dropdown) {
        if (root.classList.contains('search-topic-filter--open')) {
            this.close(root, dropdown);
        } else {
            this.open(root, dropdown);
        }
    }

    /**
     * Открывает панель и на мобильном блокирует прокрутку страницы.
     */
    open(root, dropdown) {
        dropdown.removeAttribute('hidden');

        if (this.isMobile()) {
            document.body.style.overflow = 'hidden';
        }

        window.requestAnimationFrame(() => {
            root.classList.add('search-topic-filter--open');
        });
    }

    /**
     * Скрывает панель и возвращает прокрутку страницы.
     */
    close(root, dropdown) {
        root.classList.remove('search-topic-filter--open');
        dropdown.setAttribute('hidden', '');
        document.body.style.overflow = 'auto';
    }

    /**
     * Снимает выбранные темы и отправляет форму поиска.
     */
    reset(form) {
        form.querySelectorAll('.search-topic-filter__input').forEach((input) => {
            if (input instanceof HTMLInputElement) {
                input.checked = false;
            }
        });

        form.requestSubmit();
    }
}

export default SearchTopicFilter;